var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7193 7.59996V4.39998C12.7193 3.76347 12.4609 3.15302 12.0009 2.70294C11.541 2.25285 10.9172 2 10.2667 2L6.99664 9.19995V17.9999H16.2183C16.6126 18.0043 16.9952 17.869 17.2957 17.6191C17.5961 17.3692 17.7942 17.0214 17.8533 16.6399L18.9815 9.43995C19.017 9.21064 19.0012 8.9765 18.9351 8.75376C18.8691 8.53102 18.7543 8.325 18.5988 8.14997C18.4432 7.97495 18.2507 7.83511 18.0344 7.74014C17.8182 7.64517 17.5834 7.59734 17.3464 7.59996H12.7193Z",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9.99915,
    width: 4.00111,
    height: 8,
    rx: 0.4,
    stroke: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpOutlined);
export default __webpack_public_path__ + "static/media/thumbs_up_outlined.5d1f0c80.svg";
export { ForwardRef as ReactComponent };